export default __webpack_public_path__ + "static/Tallinn_Estonia-2c979c49ec341e90a189753cff744b94.jpg";